export default "__VITE_ASSET__8fb07707__"